import { render, staticRenderFns } from "./DentalForm.vue?vue&type=template&id=b4101524&scoped=true&"
import script from "./DentalForm.vue?vue&type=script&lang=js&"
export * from "./DentalForm.vue?vue&type=script&lang=js&"
import style0 from "./DentalForm.vue?vue&type=style&index=0&id=b4101524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4101524",
  null
  
)

export default component.exports